import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Loader2, Play } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import client from "../../api/client";
import { audioFromBase64, playBase64Mp3 } from "../../utils/audioUnlock";
import { speakWithBrowser } from "../../utils/speechFallback";
import { fireConfetti } from "../../utils/fireConfetti";

// يسمع المدير تحية الموظف قبل أن يسمعها الموظف (تُولَّد مرة واحدة وتُخزَّن).
export const GreetingPreviewButton = ({ userId }) => {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState(false);

  const preview = async () => {
    setBusy(true);
    try {
      const { data } = await client.get(`/attendance/greeting/user/${userId}`);
      if (!data?.audio) {
        const spoken = await speakWithBrowser(data?.text, i18n.language === "en" ? "en" : "ar");
        if (!spoken) {
          toast.error(t(data?.error === "tts_key_missing" ? "personal.greetingNoKey" : "personal.greetingFailed"));
          return;
        }
        fireConfetti();
        return;
      }
      fireConfetti();
      const audio = audioFromBase64(data.audio);
      try {
        await audio.play();
      } catch {
        await playBase64Mp3(data.audio);
      }
    } catch {
      toast.error(t("personal.greetingFailed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuButton
      type="button"
      className="mt-2 flex items-center gap-2 px-3 py-2 text-[11px]"
      data-testid="greeting-preview"
      disabled={busy}
      onClick={preview}
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Play className="h-3.5 w-3.5 text-primary" />}
      {t("personal.greetingPreview")}
    </NeuButton>
  );
};
